import en from './en'
import pl from './pl'
import ru from './ru'
import uk from './uk'

export const messages = {
    en,
    pl,
    ru,
    uk
}

export const supportedLocales = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'pl', name: 'Polish', nativeName: 'Polski' },
    { code: 'ru', name: 'Russian', nativeName: 'русский' },
    { code: 'uk', name: 'Ukrainian', nativeName: 'Українська' }
] as const

export type SupportedLocale = (typeof supportedLocales)[number]['code']

export const defaultLocale: SupportedLocale = 'en'
